module.exports = __webpack_public_path__ + "img/gella.a6008a69.jpg";